import { activity_name, activity_name_topic, pool_name, ipt_third_activity, is_jailbroken_phone_url, topic_id, comic_id, origin } from "../js/params"

let show_nine = false; // 显示9/10部作品，根据产品手动改 9-ture,10-false

let state = {
    activity_name: activity_name, //活动名称
    activity_name_topic: activity_name_topic,// 获取作品用活动名称
    pool_name: pool_name,// 专题池
    third_activity: ipt_third_activity,
    topic_id: topic_id,
    comic_id: comic_id,
    is_jailbroken_phone_url: is_jailbroken_phone_url,// 运营位是否支持越狱 0-不支持，1-支持
    origin: origin,// 页面来源

    is_login: false,// 是否登录
    can_track: false, // 是否可埋点
    membership_classify: "",// 会员身份
    xdevice: "",// xdevice
    is_jailbroken_phone: false,// 是否越狱设备
    app_version: 0,// app版本
    user_id: 0, // 用户id
    is_member: false, // 是否是会员

    server_time: 1603444682000,// 服务器时间
    activity_end_time: 0,// 活动结束时间

    plat_icons: [],// 平台图标
    reservation_status: 0,// 预约状态 0-未预约,1-已经预约
    activity_status: 1,// 1-预约阶段，2-开通阶段，3-不可开通/领取，4-活动结束
    subname: "",// 预约页，购买页，领取页
    can_assign_count: 4,// 剩余开通次数
    total_count: 0,// 售卖总数量
    sale_count: 0,// 已售数量
    open_price: {},// 开通会员价格 {id:0,price:0,coupon:{}}
    original_price: 257, // 原价，写死

    chosen_tab: "kuaikan", // tab选中
    plat_slide_icons: createPlatformIcon(), // 平台icons
    // platform_banners: createPlatFromBanner(), // 平台展示banner


    show_loading: false,// 显示全局loading

    show_rule: false, // 显示活动规则弹窗
    show_share: false, // 显示分享弹窗
    show_phone_number: false, // 显示手机号收集弹窗
    show_detention: false, // 显示挽留弹窗

    refresh_data: false,// 首页刷新数据
    refresh_membergood_list: false,// 刷新价格接口

    comp_init: false,// 组件开始开始初始化
    time_end: false,// 倒计时时间到

    progress_width: false,// 设置进度条长度
    is_ipad: false, //是否ipad

    member_remain_days: 0,// 会员剩余时长

    show_nine: false,// 显示9/10部作品，根据产品手动改 9-ture,10-false

    open_btn_init: false, // 支付组件是否初始化

    baidu_open_disable: false, // 从百度进入是否开通达到4次

    call_apppay:false,// 从百度进入唤起端外支付

}
function createPlatformIcon() {
    let arr = [{ icon: require("../img/tencent-icon.png"), name: "腾讯视频", type: 0, chosen: true },
    { icon: require("../img/qqmusic-icon.png"), name: "QQ音乐", type: 1, chosen: false },
    { icon: require("../img/youku-icon.png"), name: "优酷", type: 2, chosen: false },
    { icon: require("../img/kugou-icon.png"), name: "酷狗音乐", type: 3, chosen: false },
    { icon: require("../img/wangyimusic-icon.png"), name: "网易云音乐", type: 4, chosen: false },
    { icon: require("../img/qingting-icon.png"), name: "蜻蜓FM", type: 5, chosen: false },
    { icon: require("../img/baidu-icon.png"), name: "百度网盘", type: 6, chosen: false },
    { icon: require("../img/lanren-icon.png"), name: "懒人听书", type: 7, chosen: false },
    { icon: require("../img/kfc-icon.png"), name: "肯德基", type: 8, chosen: false },
    { icon: require("../img/qq-member-icon.png"), name: "QQ超级会员", type: 9, chosen: false }];

    // if (!show_nine) {
    //     arr.push({ icon: require("../img/qq-member-icon.png"), name: "QQ超级会员", type: 9, chosen: false })
    // }
    return arr;
}
function createPlatFromBanner() {
    let arr = [{
        banner: require("../img/tencent-banner.png"),
        name: "腾讯视频",
        introduce: require("../img/tencent-intro.png"),
    },
    {
        banner: require("../img/qqmusic-banner.png"),
        name: "QQ音乐",
        introduce: require("../img/qqmusic-intro.png"),
    },
    {
        banner: require("../img/youku-banner.png"),
        name: "优酷",
        introduce: require("../img/youku-intro.png"),
    },
    {
        banner: require("../img/kugou-banner.png"),
        name: "酷狗音乐",
        introduce: require("../img/kugou-intro.png"),
    },
    {
        banner: require("../img/wangyimusic-banner.png"),
        name: "网易云音乐",
        introduce: require("../img/wangyimusic-intro.png"),
    },
    {
        banner: require("../img/qingting-banner.png"),
        name: "蜻蜓FM",
        introduce: require("../img/qingting-intro.png"),
    },
    {
        banner: require("../img/baidu-banner.png"),
        name: "百度网盘",
        introduce: require("../img/baidu-intro.png"),
    },
    {
        banner: require("../img/lanren-banner.png"),
        name: "懒人听书",
        introduce: require("../img/lanre-intro.png"),
    },
    {
        banner: require("../img/kfc-banner.png"),
        name: "肯德基",
        introduce: require("../img/kfc-intro.png"),
    },
    {
        banner: require("../img/qq-member-banner.png"),
        name: "QQ超级会员",
        introduce: require("../img/qq-member-intro.png"),
    }];

    // if (!show_nine) {
    //     arr.push({
    //         banner: require("../img/qq-member-banner.png"),
    //         name: "QQ超级会员",
    //         introduce: require("../img/qq-member-intro.png"),
    //     })
    // }
    return arr;
}
export { state }


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/store/state.js